import CONSTANT from "@/services/Constant.js";

export default {
	name: "MemberItem",
	props: ['member', 'memberId', 'address'],
	computed: {
		
		txtClass(){
			return { 
			"smTxt":this.$vuetify.breakpoint.smAndDown
			}
		},
		custCardClass(){
			return { 
			"smCustCard":this.$vuetify.breakpoint.smAndDown
			}
		},
		padLRClass(){
			return { 
			"smPadLR0":this.$vuetify.breakpoint.smAndDown
			}
		},
		disNoneClass(){
			return { 
			"disNone":this.$vuetify.breakpoint.smAndDown
			}
		},
		pad0Class(){
			return { 
			"pad0":this.$vuetify.breakpoint.smAndDown
			}
		},
		transparentClass(){
			return { 
			"bckTrans":this.$vuetify.breakpoint.smAndDown
			}
		},
		transparentPad0Class(){
			return { 
			"bckTransPad0":this.$vuetify.breakpoint.smAndDown
			}
		},
		disNoneUpMdClass(){
			return { 
			"disNone":this.$vuetify.breakpoint.mdAndUp
			}
		},
	},
	methods: {
		gotoMemberDetails(memberId){
			this.$router.push('/members-detail/'+memberId);
		},
		memberAddress(mem){
			return (((mem.city)?mem.city : '') + ((mem.city && mem.state)? ',' : '') + ((mem.state)? mem.state : ''));
		},
		like(){
		}
	},
	data() {
		return {
			defaultAvatarSrc: CONSTANT.DEFAULTS.defaultAvatarSrc
		}
	}
};